// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".headlines__block[data-v-673f77ad]{margin-bottom:12px}.ask-candidate[data-v-673f77ad]{font-size:17px}@media(max-width:575.98px){.ask-candidate[data-v-673f77ad]{font-size:14px}}", ""]);
// Exports
module.exports = exports;
